import { useState, useEffect } from 'react';
import { useReactFlow, useNodeId } from '@xyflow/react';

const TextLabelContent = ({ data }: { data: any }) => {
  const { updateNodeData } = useReactFlow();
  const nodeId = useNodeId();
  const [text, setText] = useState(data.text || '');

  // Debounce update to avoid too many re-renders/history updates
  useEffect(() => {
    const timer = setTimeout(() => {
      if (nodeId) updateNodeData(nodeId, { text });
    }, 300);
    return () => clearTimeout(timer);
  }, [text, nodeId, updateNodeData]);

  return (
    <div className="relative w-full h-full">
      <textarea
        className="absolute inset-0 w-full h-full bg-transparent border-0 rounded p-6 text-sm text-slate-200 resize-none focus:outline-none nodrag overflow-hidden"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter your label text here..."
        onKeyDown={(e) => e.stopPropagation()} // Prevent triggering canvas shortcuts
      />
    </div>
  );
};

export default TextLabelContent;